// Template configurations for different letter sets and UX modes
export type UXMode = "default" | "ux-zen" | "ux-cyber" | "ux-forest" | "ux-earth" | "ux-ocean" | "ux-magazine" | "ux-fire";

export interface Template {
  id: string;
  name: string;
  icon: string; // Simple icon character for display
  letterPath: string; // Path to the letters folder
  uxMode: UXMode; // Associated UX mode
  defaultBackgroundId: string; // Associated background ID for this template
}

export const templates: Template[] = [
  {
    id: "earthy-studio",
    name: "Earthy Studio",
    icon: "🌿",
    letterPath: "/letters",
    uxMode: "default",
    defaultBackgroundId: "radial-forest"
  },
  {
    id: "neon-cyber",
    name: "Neon Cyber",
    icon: "⚡",
    letterPath: "/letters",
    uxMode: "ux-cyber",
    defaultBackgroundId: "radial-cosmic"
  },
  {
    id: "forest-canopy",
    name: "Forest Canopy",
    icon: "🌲",
    letterPath: "/letters",
    uxMode: "ux-forest",
    defaultBackgroundId: "radial-charcoal"
  },
  {
    id: "minimalist-zen",
    name: "Minimalist Zen",
    icon: "🧘",
    letterPath: "/letters",
    uxMode: "ux-zen",
    defaultBackgroundId: "radial-midnight"
  },
  {
    id: "earth-ground",
    name: "Earth Ground",
    icon: "🪨",
    letterPath: "/letters",
    uxMode: "ux-earth",
    defaultBackgroundId: "radial-brown-glow"
  },
  {
    id: "ocean-wave",
    name: "Ocean Wave",
    icon: "🌊",
    letterPath: "/letters",
    uxMode: "ux-ocean",
    defaultBackgroundId: "radial-ocean"
  },
  {
    id: "magazine-editorial",
    name: "Magazine Editorial",
    icon: "📰",
    letterPath: "/letters",
    uxMode: "ux-magazine",
    defaultBackgroundId: "radial-white-glow"
  },
  {
    id: "fire-lava",
    name: "Fire Lava",
    icon: "🔥",
    letterPath: "/letters",
    uxMode: "ux-fire",
    defaultBackgroundId: "radial-lava"
  }
];

export const defaultTemplate = templates[0];

// Generate letter mappings for a given template
export const getTemplateLetters = (template: Template): { [key: string]: string } => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'.split('');
  const letters: { [key: string]: string } = {};

  characters.forEach((char) => {
    letters[char] = `${template.letterPath}/${char}.png`;
  });

  return letters;
};
